import { useContext } from "react";
import { LiffContext } from "./LiffProvider.js";
import type { LiffContextShape } from "./types.js";

export function useLiff(): LiffContextShape {
  const ctx = useContext(LiffContext);
  if (!ctx) throw new Error("useLiff must be used inside <LiffProvider>");
  return ctx;
}

export type { LiffContextShape, LiffPageKind, LiffSession } from "./types.js";
